import React from 'react'
import "./Understand.css"

const Understand = () => {
    return (
        <>
            <div className='understand'>


                <div className='understandText'>
                    We understand that you have a lot on your plate, together let’s #accomplishmore
                </div>
                <div className='understandText link'>
                    Know more
                </div>
            </div>
        </>
    )
}

export default Understand